module.exports = __webpack_public_path__ + "static/media/Snowflake.9103377b.svg";